import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import DataTable from "react-data-table-component";

export default function ModalCoverages(props) {

    const [tableCoverages, setTableCoverages] = useState([]);
    const [pending, setPending] = useState(true);

    //When the component starts...
    useEffect(() => {
        setPending(true);
        setTableCoverages(props?.coverages);
        setPending(false);
    }, [pending]);

    const columnsCoverages = [
        {
            name: 'Descripción',
            selector: row => row.description?.toUpperCase(),
            sortable: false,
            wrap: true,
            center: true,
        },
        {
            name: 'Suma Asegurada',
            selector: row => row.sumAssured?.toLocaleString('en', {maximumFractionDigits: 2}),
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Deducible',
            selector: row => row.deductible?.toLocaleString('en', {maximumFractionDigits: 2}),
            sortable: false,
            wrap: true,
            omit: false,
            center: true
        },
        {
            name: 'Prima',
            selector: row => '$' + row.netPremium?.toLocaleString('en', {maximumFractionDigits: 2}),
            sortable: false,
            wrap: true,
            omit: false,
            center: true
        }
    ]

    const customStyles = {
        headRow: {
            style: {
                color: 'white !important',
                backgroundColor: 'var(--skrPrimary)',
                padding: '.7rem .3rem !important',
                fontFamily: 'montserratRegular !important',
                fontSize: '.8rem !important',
                borderRadius: '5px'
            },
        },
    };

    return (<>
            <Modal show={props.isOpen} onHide={props.toggle} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title>
                        <h5 className="mx-4 montserratMedium" style={{color: 'var(--skrPrimary)'}}>Coberturas</h5>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="container">
                        <div className="row border-bottom">
                            <div className="col">
                                <DataTable
                                    columns={columnsCoverages}
                                    data={tableCoverages}
                                    pagination={false}
                                    dense={true}
                                    responsive={true}
                                    compact={true}
                                    customStyles={customStyles}
                                    progressPending={pending}
                                    striped/>
                            </div>
                        </div>
                    </div>

                    <div className="row float-end">
                        <div className="col-4">
                            <button
                                className="btn btn-skr-secondary mt-2"
                                onClick={props.toggle}>Cerrar
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>

        </>
    );
}